import React from "react";
import assign from "lodash/assign";
import BaseOverlay from "./base.jsx";
import Checkout from "../partials/checkout.jsx";
import { Navigation } from "react-router";
import { RaisedButton } from "material-ui";

import TicketSalesUnlocker from "../partials/ticket-sales-unlocker.jsx";
import InjectedTenantHTML from "../partials/injected-tenant-html.jsx";

import statics from "alt-utils/lib/statics";
import connectToStores from "alt-utils/lib/connectToStores";
import OrderStore from "../../stores/OrderStore";
import AppStore from "../../stores/AppStore";
import EventStore from "../../stores/EventStore";
import PersonStore from "../../stores/PersonStore";
import CreditStore from "../../stores/CreditStore";
import OrderActions from "../../actions/OrderActions";
import EventActions from "../../actions/EventActions";
import CouponActions from "../../actions/CouponActions";
import PersonActions from "../../actions/PersonActions";

import AccountCreation from "../partials/account-creation.jsx";

export default statics(
  {
    willTransitionTo({ params, location }, replace, callback) {
      EventActions.fetchOne.defer(params.eventId);

      if (
        location.action === "POP" &&
        OrderStore.getState().orderData.subitems &&
        OrderStore.getState().orderData.subitems.length
      ) {
        // If navigating back, don't reset order flow
        return callback();
      }

      OrderActions.newOrderFlow.defer();
      PersonActions.setGuestCheckout.defer(null);
      EventActions.clearNoAllOverwrite.defer();

      let hasSetInitialQuantity = false;
      let event = EventStore.getEventById(params.eventId);
      let ticketBuckets = event
        ? event.ticket_buckets
            .filter(b => b.public && !b.applicable_pass_buckets.length)
            .map((b, index) => {
              let variants = [null].concat(b.variants.map(v => v.id));

              // If a ticket bucket has variants, don't inject any quantity (and just default everything to 0)
              if (b.variants.length) {
                hasSetInitialQuantity = true;
              }

              return variants.map((v, vIndex) => {
                let quantity = 0;
                if (!hasSetInitialQuantity && b.quantity_remaining) {
                  quantity = +location.query.quantity || 1;
                  hasSetInitialQuantity = true;
                }

                return {
                  ticket_bucket: b.id,
                  variant: v,
                  quantity: quantity
                };
              });
            })
            .reduce((b, v) => b.concat(v), [])
        : [];

      OrderActions.updateCurrentOrder.defer({
        return: location.query.return,
        event: params.eventId,
        with_credits: location.state && location.state.withCredits,
        subitems: ticketBuckets.length
          ? ticketBuckets.concat(
              TENANT.donate_inline_order_prompt
                ? [{ inline_donation: true }]
                : []
            )
          : []
      });
      CouponActions.reset.defer();

      callback();
    },
    willTransitionAway() {
      OrderActions.dropReservedSeats.defer();
    }
  },

  (
    @connectToStores
    class BuyTicketsOverlay extends React.Component {
      constructor(props) {
        super(props);

        this.state = {
          wantsToUnlockSingleTickets: false,
          noApplicableTicketBuckets: false,
          outsideCloseRequest: false,
          isSundance: true
        };

        this.cancel = this.cancel.bind(this);
        this.submit = this.submit.bind(this);
        this.outsideCloseRequestCancel = this.outsideCloseRequestCancel.bind(this);
      }

      static getStores() {
        return [AppStore, OrderStore, EventStore, PersonStore];
      }

      static getPropsFromStores() {
        var state = OrderStore.getState();
        (state.isKioskMode = AppStore.getState().isKioskMode),
          (state.kioskCode = AppStore.getState().kioskCode),
          (state.getOrderById = OrderStore.getOrderById);
        state.getEventById = EventStore.getEventById;
        state.isLoggedIn = PersonStore.getState().isLoggedIn;
        state.person = PersonStore.getState().details;
        state.guestCheckoutActiveEmail =
          PersonStore.getState().guestCheckoutActiveEmail;
        state.creditsAvailable = CreditStore.creditsAvailable();
        return state;
      }

      static get contextTypes() {
        return {
          router: React.PropTypes.object.isRequired,
          tenant: React.PropTypes.object,
          appSettings: React.PropTypes.object
        };
      }

      componentWillReceiveProps(newProps) {
        if (newProps.isKioskMode && this.isKioskMode !== newProps.isKioskMode) {
          this.isKioskMode = newProps.isKioskMode;
          OrderActions.updateCurrentOrder.defer({
            kiosk: true,
            kiosk_code: newProps.kioskCode
          });
        }

        // Close modal if just logged in to Cannes mode
        if (this.context.appSettings.cannes_mode && newProps.isLoggedIn) {
          setTimeout(
            () =>
              this.context.router.replace(
                `/schedule/${this.props.orderData.event}`
              ),
            0
          );
          return;
        }

        let hasSetInitialQuantity = false;
        let event = newProps.getEventById(this.props.orderData.event),
          applicableTicketBuckets =
            event &&
            event.ticket_buckets
              .filter(b => b.public && !b.applicable_pass_buckets.length)
              .map((b, index) => {
                let variants = [null].concat(b.variants.map(v => v.id));
                return variants.map((v, vIndex) => {
                  let quantity = 0;
                  if (!hasSetInitialQuantity && b.quantity_remaining) {
                    quantity = +this.props.location.query.quantity || 1;
                    hasSetInitialQuantity = true;
                  }

                  return {
                    ticket_bucket: b.id,
                    variant: v,
                    quantity: quantity
                  };
                });
              })
              .reduce((b, v) => b.concat(v), []);

        if (
          this.props.orderData.subitems.length === 0 &&
          event &&
          applicableTicketBuckets &&
          applicableTicketBuckets.length
        ) {
          OrderActions.updateCurrentOrder.defer({
            subitems: applicableTicketBuckets.concat(
              TENANT.donate_inline_order_prompt
                ? [{ inline_donation: true }]
                : []
            )
          });
        }

        this.setState({
          noApplicableTicketBuckets:
            event && applicableTicketBuckets.length === 0
        });
      }

      cancel(isButtonClick) {
        if (!isButtonClick && !this.props.orderSuccess && this.props.orderData.seats_confirmed) {
          this.setState({ outsideCloseRequest: true })
          return false;
        }

        if (!(this.props.orderInProgress || this.props.orderSuccess)) {
          if (
            this.props.location.state &&
            this.props.location.state.fromListing
          ) {
            this.context.router.goBack();
          } else {
            this.context.router.push(`/schedule/${this.props.orderData.event}`);
          }
        }

      }

      outsideCloseRequestCancel() {
        this.setState({ outsideCloseRequest: false });
      }

      submit() {
        if (this.props.isKioskMode) {
          // Include return_to link
          OrderActions.submitOrder(
            `${window.location.protocol}//${window.location.host}/complete_kiosk`
          );
        } else {
          OrderActions.submitOrder.defer();
        }
      }

      render() {
        const event = this.props.getEventById(this.props.orderData.event) || {},
          cannesMode = !!this.context.appSettings.cannes_mode;

        return (
          <BaseOverlay
            onRequestClose={this.cancel}
            className={this.props.className}
            zIndex={2000}
          >
            {event.external_tickets_url ? (
              <div style={{ padding: 20, textAlign: "center" }}>
                <RaisedButton
                  label={"Continue to checkout"}
                  primary={true}
                  onClick={() => {
                    let win = window.open(event.external_tickets_url, "_blank");
                    win.focus();
                  }}
                />
              </div>
            ) : this.state.noApplicableTicketBuckets ? (
              <div style={{ padding: 20 }}>
                <InjectedTenantHTML
                  content={
                    this.context.tenant.no_applicable_ticket_buckets_error
                  }
                />
              </div>
            ) : !this.state.wantsToUnlockSingleTickets &&
              this.props.appSettings.standalone_ticket_sales_locked &&
              !this.props.appSettings.user_standalone_ticket_sales_unlocked &&
              !event.standalone_ticket_sales_unlocked ? (
              <div style={{ padding: 20 }}>
                {this.context.tenant.standalone_ticket_sales_locked_error
                  .__html ? (
                  <InjectedTenantHTML
                    content={
                      this.context.tenant.standalone_ticket_sales_locked_error
                    }
                  />
                ) : (
                  this.context.tenant.standalone_ticket_sales_locked_error
                )}
                <div style={{ marginTop: 10 }}>
                  <TicketSalesUnlocker />
                </div>
              </div>
            ) : !event.id ||
              event.standalone_ticket_sales_enabled ||
              event.user_standalone_ticket_sales_enabled ||
              this.props.orderSuccess ||
              this.props.appSettings.isAdvanceSingleTicketsMode ? (
                <Checkout
                  orderInProgress={this.props.orderInProgress}
                  orderSuccess={this.props.orderSuccess}
                  orderErrorMessage={this.props.orderErrorMessage}
                  orderData={this.props.orderData}
                  orderSeatTimeout={this.props.orderSeatTimeout}
                  orderShowDonateInterstitial={
                    this.props.orderShowDonateInterstitial
                  }
                  updateCurrentOrder={OrderActions.updateCurrentOrder}
                  completedOrder={this.props.getOrderById(
                    this.props.completedOrderId
                  )}
                  outsideCloseRequest={this.state.outsideCloseRequest}
                  outsideCloseRequestCancel={this.outsideCloseRequestCancel}
                  person={this.props.person}
                  isLoggedIn={this.props.isLoggedIn}
                  allowGuestCheckout={true}
                  guestCheckoutActiveEmail={this.props.guestCheckoutActiveEmail}
                  creditsAvailable={this.props.creditsAvailable}
                  initialCouponCode={this.props.location.query.discount_code}
                  event={event}
                  requiresUnlock={
                    this.props.appSettings.standalone_ticket_sales_locked
                  }
                  isUnlocked={
                    this.props.appSettings.user_standalone_ticket_sales_unlocked
                  }
                  cancel={this.cancel}
                  submit={this.submit}
                />
              )
           : cannesMode ? (
              // Cannes - allow inline login
              <div
                style={{ padding: 20, textAlign: "center", fontSize: "11pt" }}
              >
                <AccountCreation
                  loginProps={{
                    backIfTargetOkay: true,
                    targetResourceType: "event",
                    targetResourceId: event.id
                  }}
                />
              </div>
            ) : (
              <div
                style={{ padding: 20, textAlign: "center", fontSize: "11pt" }}
              >
                {this.context.tenant.standalone_ticket_sales_disabled_error
                  .__html ? (
                  <InjectedTenantHTML
                    content={
                      this.context.tenant.standalone_ticket_sales_disabled_error
                    }
                  />
                ) : (
                  this.context.tenant.standalone_ticket_sales_disabled_error
                )}

                {// "Learn more about passes" button
                this.context.tenant.passes_enabled &&
                this.context.tenant
                  .standalone_ticket_sales_disabled_error_show_passes_button ? (
                  <div style={{ marginTop: 10 }}>
                    <RaisedButton
                      label={
                        this.context.tenant
                          .standalone_ticket_sales_disabled_error_passes_button_text ||
                        `Learn more about ${this.context.tenant.display_passes}`
                      }
                      primary={true}
                      onClick={() =>
                        this.context.router.push(
                          `/${this.context.tenant.passes_url_pathname}/buy`
                        )
                      }
                    />
                  </div>
                ) : null}

                {// "Learn more about memberships" button
                this.context.tenant.memberships_enabled &&
                this.context.tenant
                  .standalone_ticket_sales_disabled_error_show_memberships_button ? (
                  <div style={{ marginTop: 10 }}>
                    <RaisedButton
                      label={
                        this.context.tenant
                          .standalone_ticket_sales_disabled_error_memberships_button_text ||
                        `Learn more about ${this.context.tenant.display_memberships}`
                      }
                      primary={true}
                      onClick={() =>
                        this.context.router.push(
                          `/${this.context.tenant.memberships_url_pathname}/buy`
                        )
                      }
                    />
                  </div>
                ) : null}

              </div>
            )}
          </BaseOverlay>
        );
      }
    }
  )
);



// WEBPACK FOOTER //
// ./src/app/components/overlays/buy-tickets.jsx